<app-system-message></app-system-message>
<div class="chat-drag-box">
  <div
    [ngClass]="theme.getThemeClass()"
    class="main-container chat-window"
    #chatWindow
    cdkDrag
    cdkDragBoundary=".chat-drag-box"
  >
    <!-- Resize edges -->
    <div
      class="resize-handle corner top-left"
      (mousedown)="startEdgeResize($event, 'corner-top-left')"
    ></div>
    <div
      class="resize-handle corner top-right"
      (mousedown)="startEdgeResize($event, 'corner-top-right')"
    ></div>
    <div
      class="resize-handle corner bottom-left"
      (mousedown)="startEdgeResize($event, 'corner-bottom-left')"
    ></div>
    <div
      class="resize-handle corner bottom-right"
      (mousedown)="startEdgeResize($event, 'corner-bottom-right')"
    ></div>
    <div
      class="resize-handle edge-top"
      (mousedown)="startEdgeResize($event, 'top')"
    ></div>
    <div
      class="resize-handle edge-bottom"
      (mousedown)="startEdgeResize($event, 'bottom')"
    ></div>
    <div
      class="resize-handle edge-left"
      (mousedown)="startEdgeResize($event, 'left')"
    ></div>
    <div
      class="resize-handle edge-right"
      (mousedown)="startEdgeResize($event, 'right')"
    ></div>
    <!-- Chat Close button -->
    <div class="chat-header">
      <div class="closeBTN">
        <span (click)="closeModal()"><i class="fa-solid fa-xmark"></i></span>
      </div>
    </div>
    <!-- Chat body -->
    <div class="modalBody">
      <!-- Side bar with contact list -->
      <aside
        [ngClass]="[theme.getThemeClass()]"
        #contactListRef
        class="slider-wrap contactClosed "
      >
        <!-- Header with search bar -->
        <div class="contactHeader" [ngClass]="theme.getThemeClass()">
          <!-- Mobile close button for side bar -->
          <div class="closeBTN closeBTNContact">
            <span (click)="closeContact()"
              ><i class="fa-solid fa-xmark"></i
            ></span>
          </div>
          <div class="inputContact">
            <!-- Contact search bar -->
            <input
              type="search"
              id="search-box"
              aria-label="Search"
              aria-describedby="search-addon"
              class="contact-search"
              [(ngModel)]="contactSearch"
              placeholder="{{ 'searchContact' | translate }}"
              (input)="onContactFilterChange()"
            />
          </div>
        </div>

        <div class="chat-contacts-height">
          @for (type of userTypes; track type) {
            @if (!(type === 'client' && isUserClient)) {
              <div
                class="contact-group-header"
                [ngClass]="[
                  theme.getThemeClass(),
                expandedUserType[type] ? 'tab-active' : ''
              ]"
              (click)="toggleUserType(type); toggleFlipped(icon)"
            >
                {{  capitalizeFirstLetter(type)  | translate }} ({{
                  filteredGroupedContacts[type].length || 0
                }})

                @if (hasUnreadInType(type)) {
                  <span class="role-notification-badge">
                    <i class="fa-solid fa-circle text-danger"></i>
                  </span>
                }
                <span #icon class="sort-icon">
                  <i class="fa-solid fa-angle-up"></i>
                </span>
              </div>
            }
            <!-- Contact List for each user types -->
            @if ((expandedUserType[type] && groupedContacts[type]) || (type === 'client' && isUserClient)) {
              @if (type === 'client') {
                <ul class="contact-list">
                  @for (clientId of clientGroupIds; track clientId) {
                    <li
                      class="contact-group-header"
                      [ngClass]="[
                        theme.getThemeClass(),
                        expandedClientGroup[clientId] ? 'tab-active' : '',
                        !isUserClient ? 'client-child-tab' : ''
                      ]"
                      (click)="toggleClientGroup(clientId); toggleFlipped(clientIcon)"
                    >
                      @if (getEntityInfoById(clientId) ) {
                        {{ getEntityInfoById(clientId)?.name }}
                      } @else {
                        {{ "Unknown Client" }}
                      }
                      ({{ filteredGroupedClientContacts[clientId]?.length || 0 }})
                      <span #clientIcon class="sort-icon">
                        <i class="fa-solid fa-angle-up"></i>
                      </span>
                    </li>
                    @if (expandedClientGroup[clientId]) {
                      @for (contact of filteredGroupedClientContacts[clientId]; track contact.user) {
                        <li
                          [id]="contact.user"
                          class="contact"
                          (click)="openConversation(contact.user)"
                          [ngClass]="{
                            selected: contact.user === chatRecipient,
                            'bg-dark': theme.themeStatus.includes('bg-dark'),
                            'bg-light': theme.themeStatus.includes('bg-light'),
                            'text-white': theme.themeStatus.includes('bg-dark'),
                            'text-dark': theme.themeStatus.includes('bg-light')
                          }"
                        >
                          <div
                            class="profile"
                            [ngStyle]="{
                              'background-color': getStatusColor(contact.status)
                            }"
                          >
                            {{ contact.given_name[0] }}
                          </div>
                          @if (contact?.user_type?.toLowerCase() === 'muirwood' && isUserClient) {
                            <span class="name">
                              {{ "channel" | translate }} {{ contact?.family_name }}
                            </span>
                          } @else {
                            <span class="name">
                              {{ contact?.given_name + " " + contact?.family_name }}
                            </span>
                          }
                          @if (getUnreadCountForContact(contact.user) > 0) {
                            <div class="notification">
                              <span class="notification-number">
                                {{ getUnreadCountForContact(contact.user) }}
                              </span>
                            </div>
                          }
                        </li>
                      }
                    }
                  }
                </ul>
              } @else {
                <ul class="contact-list">
                  @for (contact of filteredGroupedContacts[type]; track contact.user) {
                    <li
                      id="{{ contact.user }}"
                      class="contact"
                      (click)="openConversation(contact.user)"
                      [ngClass]="{
                        selected: contact.user === chatRecipient,
                        'bg-dark': theme.themeStatus.includes('bg-dark'),
                        'bg-light': theme.themeStatus.includes('bg-light'),
                        'text-white': theme.themeStatus.includes('bg-dark'),
                        'text-dark': theme.themeStatus.includes('bg-light')
                      }"
                    >
                      <div
                        class="profile"
                        [ngStyle]="{
                          'background-color': getStatusColor(contact.status)
                        }"
                      >
                        {{ contact.given_name[0] }}
                      </div>
                      @if (contact?.user_type?.toLowerCase() === 'muirwood' && isUserClient) {
                        <span class="name">
                          {{ "channel" | translate }} {{ contact?.family_name }}
                        </span>
                      } @else {
                        <span class="name">
                          {{ contact?.given_name + " " + contact?.family_name }}
                        </span>
                      }
                      @if (getUnreadCountForContact(contact.user) > 0) {
                        <div class="notification">
                          <span class="notification-number">
                            {{ getUnreadCountForContact(contact.user) }}
                          </span>
                        </div>
                      }
                    </li>
                  }
                </ul>
              }
            }
          }
        </div>
        <!-- Contact List -->
      </aside>
      <!-- Message section -->
      <section class="modelBody">
        <div class="recipientBanner" [ngClass]="theme.getThemeClass()">
          <!-- Button toggle contact list -->
	          <button
	            class="icon btn contact-list-toggler bi bi-people"
	            (click)="toggleContact()"
	            #toggleButton
	          >
	            @if (this.chatService.getUnreadCount(undefined, 'all') > 0) {
	              <span class="notification contact-btn">
	                {{ this.chatService.getUnreadCount(undefined,'all') }}
	              </span>
	            }
	          </button>
	          @if (chatBanner) {
	            <div class="recipientName">
              <!-- Status buble -->
              <span
                class="chatBannerStatus"
                [ngStyle]="{
                      'background-color': getStatusColor(chatBanner.status)
                  }"
              ></span>
              <!-- Contact Name -->
              {{ chatBanner.given_name }} {{ chatBanner.family_name }} -
              <!-- Contact role -->
              <span>{{ getRoleLabel(chatBanner.current_role) | translate}}</span>
            </div>
            <!-- Contact Meta data -->
	            <div class="recipientMeta">
	              <!-- Contact Info Dropdown Button -->
	              <div class="contactDropdownContainer" (mousedown)="disableDrag($event)" #contactInfo>
	                @if (chatBanner.user_type != 'muirwood') {
	                  <button
	                    (click)="showContactInfo = !showContactInfo"
	                    class="contactToggle"
	                  >
	                    <i class="fa-solid fa-address-book"></i> Contact Info
	                  </button>
	                }

	                @if (showContactInfo) {
	                <div class="contactDropdown">
	                  <!-- Contact Email -->
	                  <div (click)="copyToClipboard(chatBanner.email)" class="meta-data">
	                    <i class="fa-solid fa-envelope"></i>
	                    <span>{{ chatBanner.email }}</span>
	                  </div>
	                  <!-- Contact phone number -->
	                  @if (chatBanner.phone_number) {
	                    <div (click)="copyToClipboard(chatBanner.phone_number)" class="meta-data">
	                      <i class="fa-solid fa-phone"></i>
	                      <span class="chatBannerPhone">{{
	                        chatBanner.phone_number
	                      }}</span>
	                    </div>
	                  }
	                  @if (chatBanner.associated_entity_id && getEntityInfoById(chatBanner.associated_entity_id)) {
	                    <div>
	                      <i class="fa-solid fa-user"></i>
	                      <span class="chatBannerEntityId">
	                        {{
	                          getEntityInfoById(chatBanner.associated_entity_id)!.type
	                            | translate
	                        }}:
	                        {{ getEntityInfoById(chatBanner.associated_entity_id)?.name }}
	                      </span>
	                    </div>
	                  }
	                </div>
	                }
	              </div>

            </div>
	          }
        @if (tabs.length > 0) {
          <div class="conversation-tabs" [ngClass]="theme.getThemeClass()" (mousedown)="disableDrag($event)">
            @for (tab of tabs; track tab.sub) {
              <div
                [ngClass]="theme.getThemeClass()"
                class="tab"
                [class.active]="tab.sub === activeTab.sub"
                (click)="selectTab(tab)"
              >
                <span class="tab-title">
                  {{ tab.recipient }}
                </span>
                <span class="close-tab" (click)="closeConvoTab(tab, $event)">×</span>
                &nbsp;
                @if (getUnreadCountForContact(tab.sub) > 0) {
                  <div class="notification">
                    <span class="notification-number">
                      {{ getUnreadCountForContact(tab.sub) }}
                    </span>
                  </div>
                }
              </div>
            }
          </div>
        }

        </div>

        <article class="modalTab">
          <!-- Tab container for other displays -->
          <div [ngClass]="theme.getThemeClass()" class="chat-container"  >
            <!-- Message wrapper -->
            <div class="message-wrap">

              @for (convo of chatService.userConvos; track $index; let ci = $index) {
                @if (
                  chatRecipient === convo.conversation.userSub_1 ||
                  chatRecipient === convo.conversation.userSub_2
                ) {
                <div
                  class="messages"
                 #messageContainer
                  [hidden]="!(chatLog !== undefined && chatLog.length > 0)"
                >
                    <!-- Grouped messages by date -->
                    @for (group of ((groupedMessages$ | async) ?? []); track $index; let gi = $index) {
                      <div>
                      <!-- Date header (e.g., Today, Yesterday, Date) -->
                      <div class="date-header">
                        <hr class="line" />
                        {{ group.dateLabel }}
                        <hr class="line" />
                      </div>

                      <!-- Messages within that date group -->
                      @for (message of group.messages; track $index; let mi = $index) {
                      <div
                        class="messageLine"
                        [ngStyle]="{
                          'justify-content':
                            userSub === message.sender_sub
                              ? 'flex-end'
                              : 'flex-start'
                        }"
                      >
                        <!-- Message container -->
                        <div
                          class="messageContainer"
                          (mousedown)="disableDrag($event)"
                          [ngClass]="{
                            messageReceived:
                              userSub !== message.sender_sub &&
                              getMessageCategory(message) !== 'file',
                            'no-background':
                              getMessageCategory(message) === 'file'
                          }"
                        >
                          <!-- message content -->
                          <span class="message">
                            <!-- Display images -->
                            @if (getMessageCategory(message) === 'image') {
                              <!-- Image -->
                              <img
                                [src]="getResourceUrl(message.content)"
                                alt="Shared Image"
                                width="200"
                                (click)="openImageModal(message.content)"
                                class="image-thumbnail"
                              />
                            }
                            <!-- Display videos -->
                            @if (getMessageCategory(message) === 'video') {
                              <!-- Video -->
                              <video controls style="cursor: pointer;" (click)="openVideoModal(getResourceUrl(message.content))">
                                <source
                                  [attr.src]="getResourceUrl(message.content)"
                                  type="video/mp4"
                                />
                                {{ "videoNotSupported" | translate }}
                              </video>
                            }
                            <!-- Display audios -->
                            @if (getMessageCategory(message) === 'audio') {
                              <audio controls>
                                <source
                                  [attr.src]="getResourceUrl(message.content)"
                                  type="audio/mpeg"
                                />
                                {{ "audioNotSupported" | translate }}
                              </audio>
                            }
                            <!-- Display files -->
                            @if (getMessageCategory(message) === 'file') {
                              <div class="file-preview">
                                <!-- file icon -->
                                <i
                                  class="fa file-icon"
                                  [ngClass]="{
                                    'fa-file-pdf':
                                      getFileExtension(message.content) ===
                                      'pdf',
                                    'fa-file-word': ['doc', 'docx'].includes(
                                      getFileExtension(message.content)
                                    ),
                                    'fa-file-excel': ['xls', 'xlsx'].includes(
                                      getFileExtension(message.content)
                                    ),
                                    'fa-file-archive':
                                      getFileExtension(message.content) ===
                                      'zip',
                                    'fa-file': ![
                                      'pdf',
                                      'doc',
                                      'docx',
                                      'xls',
                                      'xlsx',
                                      'zip'
                                    ].includes(
                                      getFileExtension(message.content)
                                    )
                                  }"
                                  aria-hidden="true"
                                  style="font-size: 24px; margin-right: 8px"
                                ></i>
                                <!-- Download button -->
                                <button
                                  type="button"
                                  (click)="downloadFile(message.content)"
                                  class="file-download"
                                >
                                  {{ getSanitizedFileName(message.content) }}
                                </button>
                              </div>
                            }
                            <!-- Display text -->
                            @if (getMessageCategory(message) === 'text') {
                              <span  (click)="copyToClipboard(message.content)" style="cursor: pointer;">{{ message.content }}</span>
                            }
                            <!-- Message meta data -->
                            <span
                              class="messageCheck"
                              [ngClass]="{
                                messageCheck: userSub === message.sender_sub,
                                messageCheckReceiver:
                                  userSub !== message.sender_sub
                              }"
                            >
                              <!-- message time -->
                              <span
                                class="messageTime"
                                [ngStyle]="{
                                  color:
                                    theme.getThemeClass() ===
                                    'bg-light text-dark'
                                      ? 'black'
                                      : 'white'
                                }"
                                >{{ getMessageTime(message.timestamp) }}</span
                              >
                              &nbsp;
                              <!-- Message status (delivered) -->
                              @if (message.status === 'delivered' && userSub === message.sender_sub) {
                                <i class="fa-solid fa-check"></i>
                              }
                              <!-- Message status (read) -->
                              @if (message.status === 'read' && userSub === message.sender_sub) {
                                <i class="fa-solid fa-check-double" style="color: green"></i>
                              }
                            </span>
                          </span>
                        </div>
                      </div>
                      }
                    </div>
                    }
                </div>
                }
              }
              <!-- No conversation view -->
              @if (showCreateConvo && noConvo) {
              <div class="noConvoTemplate">
                <!-- No conversation message -->
                <p>
                  {{ "noConvo" | translate }}
                  {{ this.getContactDisplayName(this.chatRecipient) }}
                </p>
                <!-- Create conversation button -->
                <button
                  class="btn btn-dropdown"
                  (click)="createConversation(this.chatRecipient)"
                >
                  {{ "createConvo" | translate }}
                </button>
              </div>
              }
              <!-- Initial message view promptinmg to select a user -->
              @if (showSelectUser) {
              <div class="noConvoTemplate">
                <p>
                  {{ "selectChatUser" | translate }}
                </p>
              </div>
              }
              <!-- No active message in conversation view -->
              @if (showNoMessages || noMessages) {
              <div class="noConvoTemplate">
                <p>
                  {{ "noMessages" | translate }}
                </p>
              </div>
              }
            </div>
            <!-- Message bar container -->
            <div class="messageBar" >
              <span class="ctrl-c" [hidden]="!textCopied">{{"ctrl-c"| translate}}</span>
              <div class="input" (mousedown)="disableDrag($event)">
                <!-- Message bar -->
                <input
                  [(ngModel)]="newMessage"
                  placeholder="{{ 'typeMessage' | translate }}"
                  type="text"
                  (keydown.enter)="sendMessage()"
                  [disabled]=" showSelectUser || showCreateConvo || this.sendingMessage "
                />
                <!-- Attach file button -->
                <button
                   [disabled]=" showSelectUser || showCreateConvo || this.sendingMessage "
                  class="icon"
                  (click)="attachFile()"
                >
                  <i class="fa-solid fa-paperclip"></i>
                </button>
                <!-- Attach picture button -->
                <button
                   [disabled]=" showSelectUser || showCreateConvo || this.sendingMessage "
                  class="icon"
                  (click)="addPicture()"
                >
                  <i class="fa-solid fa-image"></i>
                </button>
                <!-- Screen share button -->
                @if (!isScreenSharing) {
                <button
                   [disabled]=" showSelectUser || showCreateConvo "
                  class="icon"
                  (click)="startScreenShare()"
                >
                  <i class="fa-solid fa-record-vinyl"></i>
                </button>
                }
                <!-- Stop screen sharin - available when screen share active -->
                @if (isScreenSharing) {
                <button
                   [disabled]=" showSelectUser || showCreateConvo"
                  class="icon"
                  (click)="stopScreenShare()"
                >
                  <i class="fa-solid fa-record-vinyl screenSharing"></i>
                </button>
                }
              </div>
              <!-- Mobile menu for attachFile and addPicture -->

              <div class="messageBarBtn">

                <!-- Send button -->
                <button
                  class="icon sendBtn"
                  (click)="sendMessage()"
                  [disabled]=" showSelectUser || showCreateConvo || this.sendingMessage "
                  (mousedown)="disableDrag($event)"
                >
                  <i style="color: white" class="fa-solid fa-paper-plane"></i>
                </button>
                <!-- Hidden image input -->
                <input
                  type="file"
                  id="imageInput"
                  (change)="onFileSelected($event)"
                  accept="image/*"
                  [hidden]="true"
                />
                <!-- Hidden file input -->
                <input
                  type="file"
                  id="fileInput"
                  (change)="onFileSelected($event)"
                  accept="
                     video/*,
                     audio/*,
                     application/pdf,
                     application/msword,
                     application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                     application/vnd.ms-excel,
                     application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                     application/zip,
                     application/x-zip-compressed,
                     .js, .ts, .py, .java, .c, .cpp, .h, .hpp, .rb, .php, .cs, .sh, .bat, .ps1, .go, .rs, .json, .xml, .html, .css, .scss, .md, .txt
                    "
                  [hidden]="true"
                />
              </div>
            </div>
          </div>
        </article>
      </section>
    </div>
  </div>
</div>
<!-- Modal for displaying screen share request -->
@if (showModal) {
<div
  [ngClass]="theme.getThemeClass()"
  class="screenShareRequest"
>
  <div class="modal-content">
    <p>{{ "acceptScreenShareRequest" | translate }}</p>
    <div class="screenBTN">
      <!-- Accept -->
      <button class="btn btn-dropdown" (click)="acceptScreenShare()">
        {{ "accept" | translate }}
      </button>
      <!-- Reject -->
      <button class="btn btn-dropdown" (click)="rejectScreenShare()">
        {{ "reject" | translate }}
      </button>
    </div>
  </div>
</div>
}
<!-- </div> -->
<!-- Modal for displaying image -->
@if (isModalOpen) {
<div class="modal-overlay" (click)="closeImageModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <img [src]="selectedImage" alt="Enlarged Image" class="modal-image" />
    <button (click)="closeImageModal()" class="close-btn">X</button>
  </div>
</div>
}
<!-- Modal for displaying screen share -->
<div class="screenShareModal" [hidden]="!isScreenSharing">
  <video #screenShareVideo muted autoplay></video>
</div>
<!-- Modal for displaying videos -->
@if (isVideoModalOpen) {
<div class="video-modal" >
  <div class="video-modal-content" >
    <button class="close-button" (click)="closeVideoModal()">✖</button>
    <video controls autoplay style="max-width: 100%; max-height: 80vh">
      <source [attr.src]="selectedVideoUrl" type="video/mp4" />
      {{ "videoNotSupported" | translate }}
    </video>
  </div>
</div>
}
